// Elementi comuni delle pagine del negozio
import React from 'react';
import { motion } from 'framer-motion';
import { useShop } from './ShopContext';

export function PageHeader({ title, subtitle }) {
  const { style } = useShop();
  const centered = style.centered;
  return (
    <div className={`max-w-6xl mx-auto px-4 pt-10 md:pt-14 pb-6 ${centered ? 'text-center' : ''}`}>
      <h1 className={`${style.heading} text-3xl md:text-4xl text-slate-900`}>{title}</h1>
      {subtitle && <p className={`mt-3 text-slate-600 max-w-2xl ${centered ? 'mx-auto' : ''}`}>{subtitle}</p>}
    </div>
  );
}

export function Section({ title, action, children, className = '' }) {
  const { style } = useShop();
  const centered = style.centered;
  return (
    <section className={`max-w-6xl mx-auto px-4 py-10 md:py-14 ${className}`}>
      {(title || action) && (
        <div className={`flex items-end gap-4 mb-6 ${centered ? 'flex-col items-center text-center' : 'justify-between'}`}>
          {title && <h2 className={`${style.heading} text-2xl md:text-3xl text-slate-900`}>{title}</h2>}
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function PrimaryButton({ children, className = '', ...props }) {
  const shop = useShop();
  return (
    <button type="button" className={`inline-flex items-center justify-center gap-2 px-6 py-3 ${shop?.style?.btn || 'rounded-full'} bg-shop-primary text-white font-medium hover:bg-shop-primary-dark transition-colors ${className}`} {...props}>
      {children}
    </button>
  );
}

export function GhostLink({ children, className = '', as: As = 'span', ...props }) {
  return (
    <As className={`inline-flex items-center gap-1 text-sm font-medium text-shop-primary hover:underline underline-offset-4 ${className}`} {...props}>
      {children}
    </As>
  );
}

// Marchio Rarifex discreto (co-branding): piccolo logo su fondo bianco + nome
export function RarifexMark({ className = '', label = 'Rarifex' }) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span className="inline-flex items-center justify-center w-4 h-4 rounded-sm bg-white overflow-hidden">
        <img src="/favicon-32x32.png" alt="" className="w-3.5 h-3.5" />
      </span>
      <span className="font-semibold tracking-wide">{label}</span>
    </span>
  );
}

// Comparsa morbida delle sezioni allo scorrimento
export function Reveal({ children, delay = 0, className = '' }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.6, ease: 'easeOut', delay }}
    >
      {children}
    </motion.div>
  );
}
